import axios from 'axios';
// import { HOST_API } from 'src/config-global';
import {
  ASSETS_API,
  ASSETS_API_CORRESPONDENCIA,
  ASSETS_API_TRAMITES,
  ASSETS_API_TICKETS,
} from 'src/config-global';

// ----------------------------------------------------------------------

// const axiosInstance = axios.create({ baseURL: HOST_API });
const axiosCorrespondenciaInstance = axios.create({ baseURL: ASSETS_API_CORRESPONDENCIA });
const axiosTramitesInstance = axios.create({ baseURL: ASSETS_API_TRAMITES });
const axiosTicketInstance = axios.create({ baseURL: ASSETS_API_TICKETS });
const axiosInstance = axios.create({ baseURL: ASSETS_API });

axiosCorrespondenciaInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Algo salió mal')
);

axiosTramitesInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Algo salió mal')
);

axiosTicketInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Algo salió mal')
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Algo salió mal')
);

// export { axiosTramitesInstance, axiosInstance };
export { axiosTramitesInstance, axiosTicketInstance, axiosCorrespondenciaInstance };
// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });
  // const res = await axiosCorrespondenciaInstance.get(url, { ...config });

  return res.data;
};

// Fetcher específico para correspondencia (tu backend local)
export const fetcherCorrespondencia = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosCorrespondenciaInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/v1/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },

  // correspondencia wil
  hoja_ruta: {
    buscarAsignacion: '/api/v1/buscar-asignacion-persona?filters[es_director]=true',
    buscarProgramas: '/api/v1/programa?limit=10&page=1&search=',
    buscarPersona: '/api/v1/persona?limit=10&page=1&search=',
    listarClasificacionesHojaRuta: '/api/v1/clasificacion-hoja-ruta?estado=ACTIVO',
    listarGestiones: '/api/v1/gestion?solo_activas=1',
    crearHojaRuta: 'api/v1/solicitud-tramite',
    buscarTramites: 'api/v1/tramite',
    // buscarUnidadesOrigen: '/api/v1/unidades-origen?page=10&filters[es_central]=true&search=',
    buscarUnidadesOrigen: '/api/v1/unidades-origen',
    ListarRequisitosPresentados: '/api/v1/requisitos-tramite/',
    buscarDestino: '/api/v1/buscar-asignacion-persona?search=',
    instrucciones: '/api/v1/instruccion?limit=40&page=1',
    programas_persona: '/api/v1/programas-persona/',
    programas_buscador: '/api/v1/programas/buscador',
    programas_filtros_opciones: '/api/v1/programas/filtros-opciones',
    eliminarHojaRuta: (id) => `/hoja-ruta/${id}`,
  },
  asignacion_cargo_area_persona: {
    asignacion:
      '/api/v1/buscar-asignacion-persona?filters[filtrar_usuario]=false&limit=150&search=',
    crear: '/api/v1/asignacion-cargo-area-persona',
  },
  // DETALLES EN EL MODAL DE LAS DERIVACIONES
  listado_derivaciones: {
    listadogeneral: '/api/v1/solicitud-tramite',
    // listadoGeneral: ''
    detalle: (idSolicitud) => `/api/v1/solicitud-tramite/${idSolicitud}`,
  },

  // DERIVACIONES OFICIAL-COPIA
  derivacion_copia: {
    derivacion: '/api/v1/derivacion',
    derivarSolicitud: '/api/v1/derivar-solicitud',
    derivacion_copia: '/api/v1/derivacion',
    estado: (estado) => `/api/v1/derivacion?limit=100&estado_derivacion=${estado}`,
    contar: '/api/v1/derivacion-contar',
  },
  tipo_tramite: {
    tipo: '/api/v1/tipo-documento',
  },
  generar_pdf: {
    pdf: '/api/v1/tramites',
  },

  // tramites daniel
  tramites: {
    tramites: 'tramites',
    list: ({ id_gestion = '', page = 1, limit = 25, search = '', grupo_tramite = '' } = {}) => {
      const params = new URLSearchParams();
      if (id_gestion) params.append('id_gestion', id_gestion);
      if (page) params.append('page', page);
      if (limit) params.append('limit', limit);
      if (search) params.append('search', search);
      if (grupo_tramite) params.append('grupo_tramite', grupo_tramite);
      return `tramites?${params.toString()}`;
    },
    clasificacion_tramites: 'clasificacion-tramites',
    grados_academicos: 'tramites/grado-academico',
    grupoVigente: (idTramite) => `tramites/${idTramite}/grupo-vigente`,
    // https://stb.posgradoupea.edu.bo/api/v1/requisitos-tramites/ordenado/clasificacion
    requisitos_tramites: 'requisitos-tramites/ordenado/clasificacion',
  },
  requisitos: {
    requisitos: 'requisitos',
    requisitos_tramites: 'requisitos-tramites',
  },
  grupoRequisitos: {
    base: 'grupo-requisitos',
    porTramite: (idTramite) => `grupo-requisitos/tramite/${idTramite}`,
    historial: (idTramite) => `grupo-requisitos/tramite/${idTramite}/historial`,
    nuevaVersion: (idGrupo) => `grupo-requisitos/${idGrupo}/nueva-version`,
    actualizarItems: (idGrupo) => `grupo-requisitos/${idGrupo}/items`,
    configurarRegistrado: (idGrupo) => `grupo-requisitos/${idGrupo}/configurar-registrado`,
    clonar: (idGrupo) => `grupo-requisitos/${idGrupo}/clonar`,
    diff: (idA, idB) => `grupo-requisitos/${idA}/diff/${idB}`,
    analizarCorreccionGestion: (idGrupo, idGestionDestino) =>
      `grupo-requisitos/${idGrupo}/correccion-gestion?id_gestion_destino=${idGestionDestino}`,
    correccionGestion: (idGrupo) => `grupo-requisitos/${idGrupo}/correccion-gestion`,
    detalle: (idGrupo) => `grupo-requisitos/${idGrupo}`,
  },
  gestiones: {
    listar: '/api/v1/gestion?solo_activas=1',
  },

  // CORRESPONDENCIA WILL DOCUMENTOS
  documentos: {
    documento: '/api/v1/documento',
    tipo_documento: '/api/v1/tipo-documento',
    buscar_asignacion_persona: '/api/v1/buscar-asignacion-persona',
    documento_generar: '/api/v1/documento-generar/',
    documento_final_generar: '/api/v1/documento-final-generar/',
    documento_subir: '/api/v1/documento-subir',
  },
  tramitesCorrespondencia: {
    tramites: '/api/v1/tramites',
    // https://correspondencialocal.upea.bo/api/v1/rechazar-tramite
    rechazar_tramite: '/api/v1/rechazar-tramite',
    detalles_solicitud: (id) => `/api/v1/solicitud-tramite/${id}`,
    analizarCorreccionOperativa: (id) =>
      `/api/v1/solicitud-tramite/${id}/correccion-operativa/analizar`,
    correccionOperativa: (id) => `/api/v1/solicitud-tramite/${id}/correccion-operativa`,
    entregar_tramite: (id) => `/api/v1/solicitud-tramite/${id}/entrega`,
    ver_entrega: (id) => `/api/v1/solicitud-tramite/${id}/entrega`,
    listado_seguimiento: ({
      limit = 25,
      page = 1,
      search = '',
      id_clasificacion = '',
      fecha_inicio = '',
      fecha_fin = '',
      id_gestion = '',
    } = {}) => {
      const params = new URLSearchParams({ limit, page, search });
      if (id_clasificacion) params.append('id_clasificacion', id_clasificacion);
      if (fecha_inicio) params.append('fecha_inicio', fecha_inicio);
      if (fecha_fin) params.append('fecha_fin', fecha_fin);
      if (id_gestion) params.append('id_gestion', id_gestion);
      return `/api/v1/listado-seguimiento?${params.toString()}`;
    },
  },

  reportes: {
    reporteSolicitudTramite: '/api/v1/reporte-solicitud-tramite',
    hojaRuta: '/api/v1/hoja-ruta-imprimir',
    hojaRutaFinal: '/api/v1/hoja-ruta-imprimir-detallada',
  },
  dashboard: {
    totalTramites: '/api/v1/principal/totales-tramites',
  },
  conteo: {
    contarEstadosSolicitud: '/api/v1/contar-estados-solicitud',
  },
  posgraduante: {
    solicitudTramite: '/api/v1/solicitud-tramite/usuario',
  },

  // solicitud tramite
  solicitud_tramite: {
    solicitudTramiteCodigo: '/api/v1/seguimiento/tramite', // https://correspondencialocal.upea.bo/api/v1/seguimiento/tramite
    seguimientoTramite: '/api/v1/seguimiento-tramite', // https://correspondencialocal.upea.bo/api/v1/seguimiento-tramite
    requisitos: (id) => `/api/v1/solicitud-tramite/${id}/requisitos`,
    regularizarRequisitos: (id) => `/api/v1/solicitud-tramite/${id}/regularizar-requisitos`,
    observacionSolicitud: (id) => `/api/v1/solicitud-tramite/${id}/observacion-solicitud`,
    observacionesRequisitos: (id) => `/api/v1/solicitud-tramite/${id}/observaciones-requisitos`,
    intercambioOrigenDestino: (id) => `/api/v1/solicitud-tramite/${id}/intercambio-origen-destino`,
    actualizarRemitenteDestinatario: (id) =>
      `/api/v1/solicitud-tramite/${id}/remitente-destinatario`,
  },
  destinatario: {
    crear: '/api/v1/destinatario',
    buscarUnificado: '/api/v1/buscar-destinatario',
  },
  remitente: {
    sugerenciasNombre: '/api/v1/remitente/sugerencias-nombre',
    sugerenciasInstitucion: '/api/v1/remitente/sugerencias-institucion',
  },

  // Instituciones Externas
  instituciones_externas: {
    listarInstituciones: '/api/v1/institucion-externa',
    crear: '/api/v1/institucion-externa',
    detalle: (id) => `/api/v1/institucion-externa/${id}`,
  },

  // Persona
  persona: {
    registrarPersona: '/api/v1/persona',
    actualizarTelefono: (id) => `/api/v1/persona/${id}/telefono`,
  },

  // derivaciones
  derivaciones: {
    derivacionesCopia: '/api/v1/derivacion/derivar-copia', // https://correspondencialocal.upea.bo/api/v1/derivacion/derivar-copia
    observar: '/api/v1/derivacion/observar',
    corregirObservacion: '/api/v1/derivacion/corregir-observacion',
    notificacion: '/api/v1/derivacion/notificacion',
    previewSaltoContingencia: '/api/v1/derivacion/preview-salto-contingencia',
    saltoContingencia: '/api/v1/derivacion/salto-contingencia',
    saltoFinal: '/api/v1/derivacion/salto-final',
  },
  ruta: {
    sugerenciaSiguienteDerivacion: '/api/v1/sugerencia-siguiente-derivacion',
    sugerenciaSiguientePorDerivacion: '/api/v1/sugerencia-siguiente-derivacion-por-derivacion',
  },
  rutas_nodos_instrucciones: {
    // https://correspondencialocal.upea.bo/api/v1/listar-ruta-tramite
    listar_ruta: '/api/v1/listar-ruta-tramite',
    registrar_nuevo: '/api/v1/ruta-tramite',
    registrar_completo: '/api/v1/ruta-tramite-completo',
    proceso_tramite: '/api/v1/proceso-tramite',
    instruccion_area: '/api/v1/instruccion-area-administrativa',
    marcar_principal: '/api/v1/ruta-tramite',
    primera_derivacion: '/api/v1/sugerencia-primera-derivacion',
    // https://correspondencialocal.upea.bo/api/v1/sugerencia-siguiente-derivacion
    siguiente_derivacion: '/api/v1/sugerencia-siguiente-derivacion',
    siguiente_derivacion_por_derivacion: '/api/v1/sugerencia-siguiente-derivacion-por-derivacion',
  },

  // area administrativa
  area_administrativa: {
    listarArea: '/api/v1/area-administrativa',
  },
  cargo: {
    listarCargo: '/api/v1/cargo',
  },
  prefijo_profesion: {
    listarPrefijos: '/api/v1/prefijo-profesion',
  },
  categoria_cantidad: {
    listar: '/api/v1/categoria-cantidad',
  },

  // api node will
  api_node: {
    listarClasificaciones: 'tramites/clasificacion',
    listarGradosAcademicos: 'tramites/grado-academico',
    listarTramites: 'tramites',
  },
  // api node NEST tickets
  api_nest_tickets: {
    buscarTramites: '/tramites',
    buscarDocentes: '/docentes',
    registrarTicket: '/recibo',
    listarTicket: '/recibo',
    clasificacionTramite: '/clasificacion-tramite',
    listarTicketReporte: '/recibo/reporte',
    buscarnroRecibo: 'recibo/r',
    buscarcodigoRecibo: 'recibo/c',
  },
};
